import React from 'react';

import { ReactComponent as Logo } from 'assets/logo.svg';

import './styles.scss';
import { SOCIAL_NETWORKS } from 'constants/socialNetworks';

const socialNetworksArray = Object.values(SOCIAL_NETWORKS);

function Footer({ className }) {
  return (
    <footer className="footer">
      <div className="logo-container">
        <Logo />
      </div>
      <div className="content">
        <span className="title">Enrique Mejía</span>
        <span className="subtitle">Human & Web Developer</span>
        <ul className="links">
          {socialNetworksArray.map(entry => {
            return (
              <li key={entry.id} className="link">
                <a rel="noopener noreferrer" target="_blank" href={entry.profileURL}>{entry.title}</a>
              </li>
            )
          })}
        </ul>
        <span className="copyright">{`Copyright © 2020. All rights reserved.`}</span>
      </div>
    </footer>
  );
}

export default Footer;
